import type { OptionStockInput, StockHeaderItemInput } from "@/lib/gql/__generated__/graphql";

import type { OptionStockDiffStore } from "../../../../usecase/use-create-form-model/option-stock-diff-store";
import type { ServerModel } from "../../../../usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	optionStockDiffStore: OptionStockDiffStore;
};

export const convertToViewModelToInput = ({ serverModel, optionStockDiffStore }: Props): OptionStockInput => {
	const input = {
		hotelID: serverModel.optionStock.hotelID,
		headers: serverModel.optionStock.headers.map(
			(items) =>
				({
					date: items.date,
				}) satisfies StockHeaderItemInput,
		),
		items: optionStockDiffStore.getDiffItems(),
	} satisfies OptionStockInput;

	return input;
};
